// extracted by mini-css-extract-plugin
export default {"primaryPrice":"MwTOW","complementaryPrimaryPrice":"B5op3","secondaryPrice":"np5x1","gridPrice":"Z8aEX","price":"dNI5z","isSalePrice":"BR6YF"};